class Tabs {
    constructor(tabsElements) {
        try {
            this.tabsElements = tabsElements;
            const min = Math.ceil(100);
            const max = Math.floor(500);

            this.tabsElements.forEach(element => {
                let randomID = Math.floor(Math.random() * (max - min) + min);
                let inputRadio = element.querySelectorAll('input[type=radio]');
                let inputLabels = element.querySelectorAll('label');

                inputLabels[0].classList.add('active');

                inputRadio.forEach((element, i) => {
                    element.setAttribute('name', "sd-tab-radio-btn-" + randomID);
                    element.setAttribute('id', "sd-tab-" + randomID + '-' + i);
                    if (element.checked) {
                        this.activeClassOnClick(inputLabels, inputLabels[i]); //specific for defaulting tabs functionality
                    }

                });

                inputLabels.forEach((element, i) => {
                    element.setAttribute('for', "sd-tab-" + randomID + '-' + i);
                    element.addEventListener("click", () => this.activeClassOnClick(inputLabels, element));
                });
            });
        } catch (error) {
            console.log(error);
        }
    }

    activeClassOnClick(inputLabels, label) {
        inputLabels.forEach(element => {
            element.classList.remove('active');
        });
        label.classList.add('active');
    }
}

export default Tabs;
